import { useContext, useState } from "react";
import classes from "./Rules.module.css";

const RulesPage = () => {
  const [selectedTab, setSelectedTab] = useState("Starter Plan");

  const tabs = ["Starter Plan", "DFY Plan"];

  const renderContent = () => {
    switch (selectedTab) {
      case "Starter Plan":
        return (
          <>
            <p>Effective Date: October 28th, 2025</p>
            <p>
              These Terms of Use ("Agreement") govern your participation in the
              POW Starter OTP Plan ("Program"), provided by Prime Bridge
              Securities LLC ("PB") through AkriTrade, Inc. ("POW"). By
              registering, purchasing access, or using a POW trading account,
              you agree to abide by these Terms in full.
            </p>

            <h2>1. Eligibility</h2>
            <p>
              <strong>1.1</strong> You must be at least 18 years old to
              participate in the Program.
            </p>
            <p>
              <strong>1.2</strong> You confirm that you are legally permitted to
              trade financial instruments in your country of residence.
            </p>
            <p>
              <strong>1.3</strong> Each account is individual and
              non-transferable.
            </p>

            <h2>2. Account Setup</h2>
            <p>
              <strong>2.1</strong> Each simulated trading account is issued with
              a notional balance (e.g., $100,000).
            </p>
            <p>
              <strong>2.2</strong> Program fees are non-refundable once payment
              has been processed.
            </p>
            <p>
              <strong>2.3</strong> Multiple accounts are permitted but must
              comply with the diversification requirements outlined in Section
              6.
            </p>

            <h2>3. Risk Rules</h2>
            <p>
              A breach of any of the following risk management rules will result
              in account termination. Once terminated, a trader must purchase a
              new account to resume participation.
            </p>

            <h2>3.1 Daily Loss Limit</h2>
            <p>
              <strong>3.1.1</strong> Maximum daily loss: $3,000 (3% of initial
              balance).
            </p>
            <p>
              <strong>3.1.2</strong> The daily loss limit resets at 00:00
              platform time (GMT+2).
            </p>

            <h2>3.2 Maximum Trailing Loss</h2>
            <p>
              <strong>3.2.1</strong> The maximum trailing loss is 5% of the
              highest equity achieved since account creation.
            </p>
            <p>
              <strong>3.2.2</strong> After an approved withdrawal, the trailing
              loss resets based on post-withdrawal equity.
            </p>

            <h2>3.3 Daily Profit Cap</h2>
            <p>
              <strong>3.3.1</strong> Maximum daily profit: $1,000 (1% of the
              starting day's balance).
            </p>
            <p>
              <strong>3.3.2</strong> The cap applies to both realized and
              unrealized profit and resets daily at 00:00 platform time (GMT+2).
            </p>
            <p>
              <strong>3.3.3</strong> Exceeding the daily profit cap:
            </p>
            <ol>
              <li>First offense: Account reset to the starting day balance.</li>
              <li>
                Second offense: Account closure with forfeiture of profits and
                fees.
              </li>
            </ol>

            <h2>3.4 Profit Cap</h2>
            <p>
              <strong>3.4.1</strong> Maximum realized profit per trading cycle:
              $4,000 (4%). This profit cap applies strictly to the withdrawal
              event itself, regardless of how many days it takes the trader to
              accumulate the profit.
            </p>
            <p>
              <strong>3.4.2</strong> Traders are eligible to withdraw funds once
              the realized profit reaches the $4,000 cap.
            </p>
            <p>
              <strong>3.4.3</strong> Profits exceeding the $4,000 cap will not
              be credited or paid out. The moment a withdrawal is executed,
              trading is disabled and the account is placed on a 30 calendar
              days hold.
            </p>

            <h2>3.5 Absolute Profit Cap</h2>
            <p>
              <strong>3.5.1</strong> The absolute maximum total withdrawal from
              the POW Starter OTP Plan is $8,000 per $100k account.
            </p>
            <p>
              <strong>3.5.2</strong> Upon reaching this limit, traders graduate
              from the Starter Program and receive a 20% discount on any
              standard POW OTP plan.
            </p>
            <p>
              <strong>3.5.3</strong> Graduated traders are no longer eligible to
              purchase new Starter OTP accounts.
            </p>

            <h2>4. Payouts</h2>
            <p>
              <strong>4.1</strong> The first payout is available 30 days after
              the first trade is placed.
            </p>
            <p>
              <strong>4.2</strong> Subsequent payouts are permitted every 28
              days, subject to full compliance with all Program rules.
            </p>
            <p>
              <strong>4.3</strong> Payouts follow an 80/20 split — 80% to the
              trader and 20% retained by the liquidity provider.
            </p>
            <p>
              <strong>4.4</strong> Withdrawal requests that violate caps or
              anti-exploit rules will be denied.
            </p>

            <h2>5. Offences and Penalties</h2>
            <p>
              <strong>5.1</strong> Daily Profit Cap breaches follow the
              penalties outlined in Section 3.3.
            </p>
            <p>
              <strong>5.2</strong> Any two major breaches (loss or profit cap
              violations) result in permanent account closure.
            </p>
            <p>
              <strong>5.3</strong> In all cases of rule violations, profits are
              forfeited and fees are non-refundable.
            </p>

            <h2>6. Multiple Accounts and Diversification</h2>
            <p>
              <strong>6.1</strong> Traders operating multiple accounts must
              employ diversified trading strategies.
            </p>
            <p>
              <strong>6.2</strong> The following actions are strictly
              prohibited:
            </p>
            <ol>
              <li>
                Executing the same trades or symbols across multiple accounts.
              </li>
              <li>Cross-hedging positions between accounts.</li>
              <li>Mirroring trade strategies across accounts.</li>
            </ol>
            <p>
              <strong>6.3</strong> Penalty: All related accounts will be closed,
              profits withheld, and fees forfeited.
            </p>

            <h2>7. Trading Restrictions</h2>
            <p>
              <strong>7.1</strong> Use of arbitrage, latency exploitation, toxic
              order flow, or any trading activity deemed abusive by POW is
              prohibited.
            </p>
            <p>
              <strong>7.2</strong> All trading activity is monitored to ensure
              fair use and compliance.
            </p>
            <p>
              <strong>7.3</strong> Accounts found engaging in restricted
              practices are subject to termination without refund.
            </p>

            <h2>8. Program Discretion</h2>
            <p>
              <strong>8.1</strong> PB and POW reserve the right to modify,
              suspend, or terminate any account found in violation of Program
              rules.
            </p>
            <p>
              <strong>8.2</strong> Rules and payout terms may be adjusted at any
              time to maintain fairness and sustainability.
            </p>
            <p>
              <strong>8.3</strong> POW reserves the right to deny payouts or
              access to the Program in cases of suspicious or abusive activity.
              In such cases, collected fees may be refunded at PB’s or POW’s
              discretion.
            </p>

            <h2>9. Limitation of Liability</h2>
            <p>
              <strong>9.1</strong> PB and POW provide access to simulated or
              risk-managed trading accounts; no actual funds are deposited or
              traded on the trader’s behalf.
            </p>
            <p>
              <strong>9.2</strong> PB and POW shall not be held liable for any
              trading losses, market risks, or technical malfunctions beyond
              their control.
            </p>
            <p>
              <strong>9.3</strong> Participation in the Program is entirely at
              the trader’s own risk.
            </p>

            <h2>10. Governing Law</h2>
            <p>
              <strong>10.1</strong> These Terms are governed by and construed in
              accordance with the laws of Saint Vincent and the Grenadines.
            </p>
            <p>
              <strong>10.2</strong> Any disputes shall be resolved exclusively
              in the courts of Saint Vincent and the Grenadines.
            </p>

            <h2>11. Acceptance</h2>
            <p>
              <strong>11.1</strong> By registering for or participating in the
              POW Starter OTP Plan, you acknowledge that you have read,
              understood, and agreed to these Terms of Use in full.
            </p>
            <h2>12. Inactivity Rule</h2>
            <p>
              <strong>Inactivity Policy: </strong> Trading accounts that remain
              inactive for 30 consecutive calendar days will be automatically
              archived by the server. An account is considered Inactive if it
              has not executed at least one trade during the preceding 30-day
              period.
            </p>
            <p>
              Once an account has been archived due to inactivity, it will be
              permanently labeled as <strong>Inactive</strong>. Archived
              accounts are not eligible for refunds, credits, reinstatement, or
              any other form of compensation under any circumstances.
            </p>
          </>
        );
      case "DFY Plan":
        return (
          <>
            <p>POW Done-For-You Funding (DFY) Terms of Service</p>
            <p>Effective Date: 30th November 2025</p>
            <p>Program Name: POW Done-For-You Funding ("DFY Program")</p>
            <p>Program Operator: POW / AkriTrade, Inc. ("POW", "we", "us")</p>
            <p>
              Infrastructure Provider (B2B Only): Prime Bridge Securities LLC
              and/or its affiliates ("Prime Bridge" or "PB")
            </p>
            <h2>IMPORTANT NOTICE</h2>
            <ol>
              <li>
                <strong>Contracting Parties.</strong> These Terms of Service
                ("Terms") form a legally binding agreement solely between you
                (the "User") and POW. Prime Bridge is not a party to this
                agreement and provides no services directly to Users.
              </li>
              <li>
                <strong>Nature of Services.</strong> The DFY Program is not an
                investment product, collective investment scheme, deposit, or
                savings vehicle. Participation does not constitute an offer of
                securities or solicitation to invest.
              </li>
              <li>
                <strong>No Advice.</strong> Neither POW nor Prime Bridge
                provides investment, trading, financial, legal, or tax advice.
                You participate entirely at your own risk.
              </li>
            </ol>
            <h2>1. Definitions</h2>
            <ul>
              <li>
                <strong>"Account"</strong> means a DFY trading account made
                accessible through POW's platform.
              </li>
              <li>
                <strong>"Activation Payment"</strong> means the fee paid to POW
                to access the DFY Program and request a funded allocation.
              </li>
              <li>
                <strong>"Performance Share"</strong> means any conditional
                performance-based payout calculated under POW's rules.
              </li>
              <li>
                <strong>"PB Services"</strong> means brokerage infrastructure,
                execution routing, liquidity access, margin bridging, and
                settlement services provided by Prime Bridge{" "}
                <strong>exclusively to POW</strong> on a B2B basis.
              </li>
              <li>
                <strong>"Third-Party Providers"</strong> include trading
                platforms, liquidity providers, custodians, payment processors,
                and digital asset service providers.
              </li>
            </ul>
            <h2>2. Role Clarity and Legal Separation</h2>
            <p>
              2.1 <strong>POW as Sole Counterparty.</strong> POW is the sole
              operator of the DFY Program and the only contractual counterparty
              to Users.
            </p>
            <p>
              2.2 <strong>Prime Bridge Boundary.</strong> You acknowledge and
              agree that Prime Bridge:
            </p>
            <ul>
              <li>
                Does not onboard, KYC, contract with, or provide services
                directly to Users.
              </li>
              <li>
                Has no knowledge of, or responsibility for, any agreements,
                representations, or arrangements between POW and Users or third
                parties.
              </li>
              <li>
                Has no knowledge of, involvement in, or control over trading
                strategies, signals, or decision-making processes.
              </li>
              <li>Acts solely as a B2B service provider to POW.</li>
            </ul>
            <p>
              2.3 <strong>No Agency or Fiduciary Relationship.</strong> Nothing
              in these Terms creates a partnership, agency, joint venture,
              fiduciary duty, or trust relationship between you and Prime
              Bridge.
            </p>
            <h2>3. Program Overview</h2>
            <p>
              3.1 Users pay an Activation Payment to POW to request access to
              the DFY Program.
            </p>
            <p>
              3.2 POW may utilize PB Services and Third-Party Providers to
              facilitate execution, liquidity access, margin bridging, and
              operational settlement.
            </p>
            <p>
              3.3 POW may impose risk controls, trading restrictions, and
              liquidation mechanisms to protect program integrity.
            </p>
            <h2>4. Payments, Fees, and Custody</h2>
            <p>
              4.1 <strong>Activation Payment.</strong> All payments are made to
              POW and are non-refundable unless otherwise required by law.
            </p>
            <p>
              4.2 <strong>No User Custody by PB.</strong> Prime Bridge does not
              custody User funds or assets and has no payment or payout
              obligations to Users.
            </p>
            <p>
              4.3 <strong>Non-Investment Nature.</strong> Activation Payments do
              not represent deposits, equity, or ownership interests.
            </p>
            <h2>5. Performance Share and Withdrawals</h2>
            <p>
              5.1 <strong>Conditional Payouts.</strong> Performance Shares are
              subject to compliance, risk review, and operational constraints.
            </p>
            <p>
              5.2 <strong>Payment Methods.</strong> POW may process payouts via
              cryptocurrency or other methods made available in the portal.
            </p>
            <p>
              5.3 <strong>Delays and Holds.</strong> POW may delay or deny
              payouts in cases of suspected violations, fraud, abnormal trading,
              chargebacks, or technical issues.
            </p>
            <p>
              5.4 <strong>No PB Liability.</strong> Withdrawals paid by Prime
              Bridge are paid solely to POW pursuant to its B2B arrangements,
              and Prime Bridge has no knowledge of, involvement in, or
              responsibility for how POW distributes, allocates, or remits such
              funds to any Users, contractors, affiliates, or third parties.
            </p>
            <h2>6. Risk Management and Liquidation</h2>
            <p>
              6.1 DFY accounts are subject to a maximum drawdown limit of{" "}
              <strong>7.2% of the starting account balance,</strong> as
              determined and enforced by Prime Bridge as part of its risk
              controls.
            </p>
            <p>
              6.2 Prime Bridge may liquidate positions or close accounts once
              the drawdown threshold is reached. To protect the integrity of
              this limit, liquidation triggers may occur{" "}
              <strong>prior to the full 7.2% drawdown level</strong> based on
              market conditions, execution risk, liquidity constraints, or
              internal risk management thresholds.
            </p>
            <h2>7. Prohibited Conduct</h2>
            <p>Users accessing the portal may not engage in:</p>
            <ul>
              <li>Fraud, misrepresentation, or identity evasion</li>
              <li>Coordinated or abusive trading behavior</li>
              <li>Latency, arbitrage, or toxic flow exploitation</li>
              <li>Unauthorized automation or circumvention of controls</li>
            </ul>
            <p>
              Violations may result in immediate termination and forfeiture of
              payouts.
            </p>
            <h2>8. Disclaimers and Acknowledgments</h2>
            <p>
              8.1 Trading involves substantial risk and no guarantees of profit.
            </p>
            <p>
              8.2 Platform outages, execution delays, and pricing discrepancies
              may occur.
            </p>
            <p>
              8.3 Digital asset payouts involve additional risks, including
              network congestion and custody failures.
            </p>
            <h2>9. Data and Monitoring</h2>
            <p>
              9.1 POW may monitor trading activity for risk, compliance, and
              integrity purposes.
            </p>
            <p>
              9.2 Data may be shared with PB only to the extent necessary for PB
              Services.
            </p>
            <h2>10. No Warranties</h2>
            <p>
              The DFY Program is provided "as is" and "as available" without
              warranties of any kind.
            </p>
            <h2>11. Limitation of Liability</h2>
            <p>
              11.1 Neither POW nor Prime Bridge shall be liable for indirect,
              incidental, or consequential damages.
            </p>
            <p>
              11.2 POW's aggregate liability shall not exceed the Activation
              Payment paid for the relevant account.
            </p>
            <p>
              11.3 Prime Bridge's aggregate liability, if any, is capped at USD
              $100.
            </p>
            <h2>12. Release and Indemnification of Prime Bridge</h2>
            <p>
              12.1 Users fully release Prime Bridge from any claims related to
              the DFY Program.
            </p>
            <p>12.2 Users agree not to bring claims against Prime Bridge.</p>
            <p>
              12.3 Prime Bridge is an intended third-party beneficiary of this
              section.
            </p>
            <h2>13. Indemnity</h2>
            <p>
              Users agree to indemnify and hold harmless POW and Prime Bridge
              from claims arising from User conduct or violations.
            </p>
            <h2>14. Suspension and Termination</h2>
            <p>
              POW may suspend or terminate access at its discretion for risk,
              compliance, or integrity reasons.
            </p>
            <h2>15. Refund Policy</h2>
            <p>
              Activation Payments are non-refundable unless required by law.
            </p>
            <h2>16. Changes to Terms</h2>
            <p>
              POW may amend these Terms at any time. Continued use constitutes
              acceptance.
            </p>
            <h2>17. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms are governed by the laws of Saint Vincent and the
              Grenadines. Any dispute arising out of or in connection with these
              Terms shall be resolved by binding arbitration seated in Saint
              Vincent and the Grenadines, conducted in English.
            </p>
            <h2>18. Acceptance</h2>
            <p>
              By accessing or using the DFY Program, you acknowledge that you
              have read, understood, and agreed to these Terms.
            </p>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`${classes.wrapper}`}>
      <h1>Terms of Service</h1>
      <div className={classes.tabsContainer}>
        {tabs.map((tab, i) => (
          <div
            key={tab}
            className={`${classes.tab} ${
              selectedTab === tab ? classes.active : ""
            }`}
            onClick={() => setSelectedTab(tab)}
          >
            {i + 1 + ". " + tab}
            {selectedTab === tab && <div className={classes.underline} />}
          </div>
        ))}
      </div>
      <div className={classes.termsContent}>{renderContent()}</div>
    </div>
  );
};

export default RulesPage;
